//
// One rounded segment per page of a poll: the pages walked, the one on screen, the
// ones to come — the colours of the wizard steps bar, without its labels
//
import classNames from 'classnames';
import PropTypes from 'prop-types';

const doneColor = '#95d3e5';
const currentColor = 'var(--color-pxMedBlue)';
const futureColor = '#e8e8e8';

function PollProgressBar(props) {
  const {
    pageCnt,
    currentPage,
    className,
  } = props;

  return (
    <div className={classNames('shrink-0 flex flex-row gap-0.5 h-1.5', className)}>
      {Array.from(
        { length: pageCnt },
        (_unused, index) => {
          let backgroundColor = futureColor;
          if (index < currentPage) backgroundColor = doneColor;
          else if (index === currentPage) backgroundColor = currentColor;

          return (
            <div
              key={index}
              className="flex-1 rounded-full"
              style={{ backgroundColor }}
            />
          );
        },
      )}
    </div>
  );
}

PollProgressBar.propTypes = {
  pageCnt: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  className: PropTypes.string,
};

export default PollProgressBar;
